import { useAtomValue, useSetAtom } from 'jotai'

import {
  activeModalsFamily,
  closeModalAtom,
  modalCallbacksFamily,
  modalPropsFamily,
  openModalAtom,
} from '@/store/activeModal'
import { ModalCallbacks, ModalProps, ModalType } from '@/typings/Modals'

export function useModal<T extends ModalType>(modalType: T) {
  const isOpen = useAtomValue(activeModalsFamily(modalType))
  const data = useAtomValue(modalPropsFamily(modalType)) as ModalProps[T]
  const callbacks = useAtomValue(
    modalCallbacksFamily(modalType),
  ) as ModalCallbacks[T]
  const triggerOpen = useSetAtom(openModalAtom)
  const triggerClose = useSetAtom(closeModalAtom)

  return {
    isOpen,
    data,
    callbacks,
    open: (props?: ModalProps[T], callbacks?: ModalCallbacks[T]) =>
      triggerOpen(modalType, props, callbacks),
    close: () => triggerClose(modalType),
  }
}
